import { Component, OnInit, Input, TemplateRef, ContentChild, Output, EventEmitter, Injector, ElementRef } from '@angular/core';
import { Question } from '../interfaces/question';
import { QuestionsManagerComponent } from '../questions-manager/questions-manager.component';

@Component({
	selector: 'question',
	templateUrl: './question.component.html',
	styleUrls: ['./question.component.scss']
})
export class QuestionComponent implements OnInit {
	@Input() qID: string;
	@Output() elemRef:ElementRef;

	//@Input() state: string;
	//@Input() result: any = null;
	//@Output() resultChange: EventEmitter<any> = new EventEmitter<any>();
	
	parentComponent: QuestionsManagerComponent;
	
	constructor(private inj: Injector, elm:ElementRef) {
		this.parentComponent = this.inj.get(QuestionsManagerComponent);
		this.elemRef=elm;
		//console.log(this.parentComponent);
	}

	ngOnInit() {
		//this.resultChange.emit(1);
		this.parentComponent.addQuestion(this);
	}
	

	edit(qID){
		console.log("edit()");
		this.parentComponent.setEditQuestion(qID);
	}

	save(){
		console.log("save()");	
	}

}



// WEBPACK FOOTER //
// ./src/app/question/question.component.ts